import useDispensaryPromotions from "hooks/useDispensaryPromotions";

import PromoCard from "components/PromoCard";

import NoDealsOrPromos from "../NoDealsOrPromos";

const PromotionsSection = () => {
  const { promotions, ref } = useDispensaryPromotions({ loadOnScroll: true });

  return (
    <div ref={ref}>
      <h2>Promotions</h2>
      {promotions.length ? (
        <div className="text-md font-bold mb-lg">
          Know before you go! These promos are available to claim in-store. Ask
          your budtender before you checkout!
        </div>
      ) : (
        <NoDealsOrPromos type="promotions" />
      )}
      {promotions.map((promotion) => (
        <PromoCard key={promotion.id} {...promotion} className="mb-sm" />
      ))}
    </div>
  );
};

export default PromotionsSection;
